<div class="relative inline-flex items-center gap-1.5">
  <!-- Label -->
  <label *ngIf="label" class="text-[10px] font-semibold text-[var(--tertiary-text,#79747E)] uppercase tracking-wider whitespace-nowrap">{{label}}</label>
  <!-- Input -->
  <div (click)="toggle()"
    class="py-2 px-3 border-[1.5px] rounded-lg text-xs font-medium w-[140px] cursor-pointer transition-colors text-[var(--base-text-alt-dark)]"
    [class.border-[var(--primary-dark)]]="open"
    [class.border-[var(--app-border,#E8E8EC)]]="!open"
    [class.bg-[var(--app-base)]]="true">
    {{value || 'YYYY-MM-DD'}}
  </div>

  <!-- Calendar Dropdown -->
  <div *ngIf="open" class="absolute top-[calc(100%+6px)] right-0 bg-white rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-[var(--app-base,#F5F5F7)] z-[300] p-4 w-[280px]">
    <!-- Month Nav -->
    <div class="flex items-center justify-between mb-3">
      <span class="material-icons text-[20px] text-[var(--tertiary-text)] cursor-pointer hover:text-[var(--primary-dark)]" (click)="prevMonth(); $event.stopPropagation()">chevron_left</span>
      <span class="text-[14px] font-semibold">{{monthLabel}}</span>
      <span class="material-icons text-[20px] text-[var(--tertiary-text)] cursor-pointer hover:text-[var(--primary-dark)]" (click)="nextMonth(); $event.stopPropagation()">chevron_right</span>
    </div>
    <!-- Day Headers -->
    <div class="grid grid-cols-7 gap-0 mb-1">
      <span *ngFor="let d of ['Su','Mo','Tu','We','Th','Fr','Sa']" class="text-[11px] font-semibold text-[var(--tertiary-text)] text-center py-1">{{d}}</span>
    </div>
    <!-- Days -->
    <div class="grid grid-cols-7 gap-0">
      <div *ngFor="let day of days"
        class="w-9 h-9 flex items-center justify-center text-[13px] text-[var(--base-text-alt-dark)] cursor-pointer rounded-lg transition-colors"
        [class.hover:bg-[var(--app-base,#F5F5F7)]]="day"
        [class.bg-[var(--primary-dark)]]="isSelected(day)"
        [class.text-white]="isSelected(day)"
        [class.font-semibold]="isSelected(day)"
        (click)="day && selectDay(day); $event.stopPropagation()">
        {{day || ''}}
      </div>
    </div>
    <!-- Footer -->
    <div class="flex items-center justify-between mt-3 pt-3 border-t border-[var(--app-base,#F5F5F7)]">
      <span class="text-[13px] font-medium text-[var(--tertiary-text)] cursor-pointer hover:text-[var(--base-text-dark)]" (click)="clear(); $event.stopPropagation()">Clear</span>
      <span class="text-[13px] font-medium text-[var(--primary-dark)] cursor-pointer hover:opacity-80" (click)="today(); $event.stopPropagation()">Today</span>
    </div>
  </div>
</div>
